/**
 * @fileoverview Composes Chat page handler hooks.
 * @module pages/chat/useChatHandlers
 */
import useChatMessageHandlers from "./useChatMessageHandlers.js";
import useChatFileHandlers from "./useChatFileHandlers.js";
import useChatNavigationHandlers from "./useChatNavigationHandlers.js";

/**
 * Returns memoized Chat page handlers grouped by concern.
 * @param {Object} ctx - Chat context
 * @returns {Object} Handler functions for the view
 */
const useChatHandlers = (ctx) => ({
  ...useChatMessageHandlers(ctx),
  ...useChatFileHandlers(ctx),
  ...useChatNavigationHandlers(ctx),
});

export default useChatHandlers;
